













import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import DatePicker from 'vuejs-datepicker';
import DateInput from 'vuejs-datepicker';
import {de, en} from 'vuejs-datepicker/dist/locale';
import {DateRange} from '@/services/util/DateRange';

@Component({components: {DatePicker}})
export default class DatePickerVue extends Vue {

  get disabledDates() {
    return {
      from: this.validDateRange.rangeEnd,
      to: this.validDateRange.rangeStart
    };
  }

  private static isValidDate(date: string): boolean {
    if (!date) {
      return false;
    }
    const dateSplit = date.split('.') as any[];
    if (dateSplit.length < 3) {
      return false;
    }
    const year = dateSplit[2];
    const month = dateSplit[1];
    const day = dateSplit[0];
    return !isNaN(year) && !isNaN(month) && !isNaN(day) && month > 0 && month <= 12 && day >= 1 && day <= 31;

  }

  private static convertLocalToUTCDate(date: string): Date {
    const dateSplit = date.split('.') as any[];
    return new Date(Date.UTC(dateSplit[2], (+dateSplit[1] - 1), dateSplit[0]));
  }

  @Prop()
  public value?: Date;

  @Emit()
  public input(newValue: Date): Date {
    return newValue;
  }

  @Prop({required: false, default: () => DateRange.empty()})
  public validDateRange: DateRange;

  public getLocale() {
    switch (this.$i18n.locale) {
      case 'de':
        return de;
      case 'en':
        return en;
      default: // fallback
        return 'de';
    }
  }

  public mounted() {
    if (!this.value) {
      if (this.validDateRange.rangeStart) {
        this.input(this.validDateRange.rangeStart);
      } else {
        this.input(new Date());
      }
    }

    const datePickerRef = this.$refs.datePicker as DatePicker;
    if (datePickerRef) {
      const dateInputRef = datePickerRef.$children[0] as DateInput;
      // override methods, so we can introduce our own date parsing.
      dateInputRef.inputBlurred = () => {
        dateInputRef.$emit('closeCalendar');
      };
      dateInputRef.parseTypedDate = (event) => {
        // close calendar if escape or enter are pressed
        if ([
          27, // escape
          13 // enter
        ].includes(event.keyCode)) {
          dateInputRef.input.blur();
        }
        if (dateInputRef.typeable && DatePickerVue.isValidDate(dateInputRef.input.value)) {
          dateInputRef.typedDate = dateInputRef.input.value;
          dateInputRef.$emit('typedDate', DatePickerVue.convertLocalToUTCDate(dateInputRef.typedDate));
        }
      };
    }
  }
}
